import {
  FaReact,
  FaNodeJs,
  FaLaravel,
  FaDocker,
  FaGithub,
  FaGitAlt,
} from "react-icons/fa";
import {
  SiExpress,
  SiGatsby,
  SiFlutter,
  SiTailwindcss,
  SiBootstrap,
  SiVercel,
  SiFigma,
  SiFirebase,
} from "react-icons/si";

export const PROGRAMMING_LANGUAGES = [
  "JavaScript",
  "PHP",
  "TypeScript",
  "Dart",
  "Java",
  "MySQL",
  "HTML",
  "CSS",
  "SQL",
  "GraphQL",
];

export const LIBRARIES_AND_FRAMEWORKS = [
  { Icon: FaReact, name: "React" },
  { Icon: FaNodeJs, name: "Node.js" },
  { Icon: SiExpress, name: "Express" },
  { Icon: SiGatsby, name: "Gatsby" },
  { Icon: FaLaravel, name: "Laravel" },
  { Icon: SiFlutter, name: "Flutter" },
  { Icon: SiTailwindcss, name: "TailwindCSS" },
  { Icon: SiBootstrap, name: "Bootstrap" },
];

export const TOOLS_AND_UTILITIES = [
  { Icon: FaGitAlt, name: "Git" },
  { Icon: FaGithub, name: "GitHub" },
  { Icon: FaDocker, name: "Docker" },
  { Icon: SiVercel, name: "Vercel" },
  { Icon: SiFirebase, name: "Firebase" },
  { Icon: SiFigma, name: "Figma" },
];
